import React from 'react';
import './WishInfo.scss';
import { calculateAmount, formatAsCurrency } from '../Helper';

const WishInfo = props => {
  if (props.fulfilled) {
    return <p className="wish-info">Bereits erfüllt!</p>;
  }

  if (props.purchase === 'direct') {
    return <p className="wish-info">Abgeben in der Lutherkirche</p>;
  }

  return (
    <p className="wish-info">
      {formatAsCurrency(props.amountCollected)}€ -{' '}
      <strong>
        es fehlen nur noch{' '}
        {calculateAmount(props.amount, props.amountCollected)}€
      </strong>
    </p>
  );
};

export default WishInfo;



// WEBPACK FOOTER //
// ./src/Component/WishInfo.js